import { Injectable } from '@angular/core';
import { GqlServiceV2 } from '../../content/service/gql.service-v2';
import { GridInput } from '@it2go/data-grid';
import { filterFrag } from '../../../services/types/filter.types';
import { InboxOrganizationGridObject } from '@libs/types/src/inbox/object-type/inbox-organization.object';
import { inboxOrganizationGridItemFrag } from './types/inbox-organization.gql-types';

@Injectable({ providedIn: 'root' })
export class InboxOrganizationGqlService extends GqlServiceV2 {
    getInboxOrganizations(input: GridInput, frag: string = inboxOrganizationGridItemFrag) {
        return this.query<InboxOrganizationGridObject>(
            `
                query($input: GridInput!) {
                    inboxOrganization {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${frag}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }
}
